module.exports = {
      id: "textsms-usage",
      viewBox: "0 0 28.57 28.57",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#textsms",
      toString: function () {
        return this.url;
      }
    }